import React, { useEffect } from 'react';

export function RecaptchaScriptLoader() {
  useEffect(() => {
    const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    if (!RECAPTCHA_SITE_KEY) {
      console.warn('RECAPTCHA_SITE_KEY não definido no .env');
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}
